import { FundingCategoryAssemblyJunctionBase } from './base/funding-category-assembly-junction-base';

export class FundingCategoryAssemblyJunction extends FundingCategoryAssemblyJunctionBase { }